/**
 * StylingErrorMessage.tsx — Error message display for a failed styling run
 *
 * Shows the generic "System Error" message with a tooltip revealing the
 * underlying status text, and a mailto link to IT Service Desk for support.
 */

import React from "react";
import { MessageBar, MessageBarBody, MessageBarTitle, Tooltip } from "@fluentui/react-components";
import { DiamondDismissFilled } from "@fluentui/react-icons";

interface StylingErrorMessageProps {
  statusMessage: string | null;
}

export const StylingErrorMessage: React.FC<StylingErrorMessageProps> = ({ statusMessage }) => {
  return (
    <MessageBar
      intent="error"
      shape="rounded"
      icon={
        <Tooltip
          content={{ children: statusMessage ?? "", className: "error-tooltip" }}
          relationship="description"
          positioning="above-start"
        >
          <DiamondDismissFilled />
        </Tooltip>
      }
    >
      <MessageBarBody>
        <MessageBarTitle>Styling failed</MessageBarTitle>
        <span>
          with a System Error. Please try refreshing & running again. If error persists, please
          contact the{" "}
          <a
            href="mailto:itservicedesk@penguinrandomhouse.com?subject=MSS Styling Assistant failed&body=Please include the following with this email:%0D%0A %E2%80%A2 the manuscript document that produced the error,%0D%0A %E2%80%A2 the error message displayed (if any), and %0D%0A %E2%80%A2 whether you are using Mac or PC.%0D%0A%0D%0A Thank you!"
            className="styling-error-message"
          >
            IT Service Desk
          </a>
          .
        </span>
      </MessageBarBody>
    </MessageBar>
  );
};
